import AppRouter from './components/AppRouter';
import LoadingSpinner from './util/LoadingSpinner';
function App() {
  return (
    <>
        <AppRouter />
        <LoadingSpinner />
    </>
  );
}

export default App;
